import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'fsactividad',
    ...crudState()
  }),
  getters: {
    ...crudGetters,
    asignadas: state => state.all.filter(item => item.idestado !== 4),
    finalizadas: state => state.all.filter(item => item.idestado === 4),
    sinasignar: state => state.all.filter(item => !!item.idusuarioasignado)
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions

  }
}
